declare namespace $ {

	export class $mol_icon_translate extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=translate.view.tree.d.ts.map